export function styleToNumber(value: string) {
    if (typeof value !== "string") {
        return 0;
    }

    let ext = "";
    if (value.includes("px")) {
        ext = "px";
    } else if (value.includes("%")) {
        ext = "%";
    } else if (value.includes("em")) {
        ext = "em";
    }

    const number = parseFloat(value.replace(ext, ""));
    return isNaN(number) ? 0 : number;
}

export function styleZoom(
    style: { [key: string]: any },
    level: number
) {
    if (!style) return {};

    const keys = new Set([
        "top",
        "left",
        "right",
        "bottom",
        "width",
        "height",
        "padding",
        "padding-top",
        "padding-left",
        "padding-right",
        "padding-bottom",
        "margin",
        "margin-top",
        "margin-left",
        "margin-right",
        "margin-bottom",
        "font-size",
    ]);

    const newStyle: Record<string, any> = {};

    Object.entries(style).forEach(([key, val]) => {
        if (!keys.has(key)) {
            newStyle[key] = val;
            return;
        }

        let ext = "";
        if (typeof val === "string") {
            if (val.includes("px")) ext = "px";
            else if (val.includes("%")) ext = "%";
            else if (val.includes("em")) ext = "em";
        }

        const num = parseFloat(val);
        newStyle[key] = isNaN(num) ? val : `${num * level}${ext || "px"}`;
    });

    return newStyle;
}